import React from 'react'
import Typography from '@material-ui/core/Typography'
import styles from './swatch.module.scss'
import { animated, useSpring } from 'react-spring'
import { IconButton } from '@material-ui/core'
import { FaPalette } from 'react-icons/fa'
import { RiPaintFill } from 'react-icons/ri'

interface Props {
  name: string
  // type: string
  hex: any
  active: boolean
  onClickFn: () => void
}

const Swatch = ({ name, hex, active, onClickFn }: Props) => {
  const config = {
    mass: 1.4,
    tension: 1000,
    friction: 70,
  }

  const infoSpring = useSpring({
    config,
    color: active ? '#fafafa' : '#fafafaaa',
    padding: active ? '0.5rem 0.5rem 0.5rem 1rem' : '0.5rem 8rem 0.5rem 0.5rem',
    alignItems: active ? 'flex-start' : 'center',
  })

  const dividerSpring = useSpring({
    config,
    flexGrow: active ? '0' : '1',
  })

  const colSpring = useSpring({
    borderRadius: active ? '0.2rem' : '1rem',
    backgroundColor: `${hex}`,
    boxShadow: !active ? '0 0 4px rgba(0,0,0,0.4)' : '0 0 20px rgba(0,0,0,0.8)',
    height: active ? '48px' : '32px',
    width: active ? '236px' : '127px',
    right: active ? '144px' : '16px',
    config: config,
  })

  return (
    <animated.div className={styles.swatch} onClick={() => onClickFn()}>
      <animated.div
        style={{
          ...infoSpring,
          // NOTE: flexDirection and flecGrow not compatible with
          // typescript and react-spring combo
          flexDirection: active ? 'column' : 'row',
          flexGrow: active ? 0 : 1,
          justifyContent: active ? 'center' : 'space-between',
        }}
        className={styles.swatchInfo}
      >
        <Typography className={styles.typoHead}>{name}</Typography>
        {/* <Typography className={styles.typoSub}>{type}</Typography> */}
      </animated.div>
      <animated.div style={colSpring} className={styles.swatchColor}>
        <div
          style={{
            opacity: `${active ? '1' : '.5'}`,
          }}
          className={styles.swatchColorC}
        />
      </animated.div>
      {active && (
        <div>
          <IconButton style={{ justifySelf: 'flex-end' }}>
            <RiPaintFill />
          </IconButton>
          <IconButton style={{ justifySelf: 'flex-end' }}>
            <FaPalette />
          </IconButton>
        </div>
      )}
    </animated.div>
  )
}

export default Swatch
